const callnames = [
  "director",
  "producer",
  "procoord",
  "unitpm",
  "travelco",
  "produpa",
  "setmedic",
  "addpro1",
  "addpro2",
  "addpro3",
  "addpro4",
  "addpro5",
  "astdir1",
  "astdir2",
  "astdir3",
  "astdir4",
  "astdir5",
  "proast1",
  "proast2",
  "proast3",
  "locmngr",
  "locast1",
  "locast2",
  "locast3",
  "locast4",
  "locsecur",
  "dophoto",
  "camerop",
  "astcam1",
  "astcam2",
  "digitec",
  "steadicam",
  "camerapa",
  "addcam1",
  "addcam2",
  "addcam3",
  "addcam4",
  "cosdesign",
  "cosdesast",
  "warsuper",
  "keycostu",
  "truckcos",
  "setcost1",
  "setcost2",
  "wardrobe1",
  "wardrobe2",
  "wardrobe3",
  "scriptsup",
  "writer",
  "soundmix",
  "boomop",
  "sound1",
  "sound2",
  "editor",
  "vfxsuper",
  "gaffer",
  "bbelect",
  "elect3",
  "elect4",
  "keygrip",
  "bbgrip",
  "dolgrip",
  "swing1",
  "swing2",
  "swing3",
  "swing4",
  "swing5",
  "keymake",
  "keyhair",
  "fxmake",
  "fxmakast",
  "makeup1",
  "makeup2",
  "makeup3",
  "makeup4",
  "stuntco",
  "stunts1",
  "stunts2",
  "sfxsuper",
  "sfxassis1",
  "sfxassis2",
  "prodesign",
  "artdirect",
  "artstand",
  "artassist",
  "setdecor",
  "decassist",
  "setdress",
  "leadman",
  "dresser",
  "swingga1",
  "propmast",
  "propast",
  "onsetpro",
  "propbuy",
  "armorer",
  "xtracas",
  "crafts",
  "crafty",
  "trancap",
  "transpo1",
  "transpo2",
  "headrive",
  "carone",
  "cartwo",
  "carthree",
  "carfour",
  "truck2",
  "addcrew19",
  "makeup5",
  "truck3",
  "legalcon",
  "addcrew16",
  "addcrew17",
  "addcrew18",
  "addcrew20",
  "addcrew1",
  "addcrew2",
  "addcrew3",
  "addcrew4",
  "addcrew5",
  "addcrew6",
  "addcrew7",
  "addcrew8",
  "addcrew9",
  "addcrew10",
  "addcrew11",
  "addcrew12",
  "addcrew13",
  "addcrew14",
  "addcrew15",
];

export default callnames;
export { callnames };
